import React, { useCallback, useMemo, useState } from 'react';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { addVip } from '../services/vipService';

function FormVip({ websiteId: websiteIdProp }) {
  const location = useLocation();
  const { website_id: websiteIdFromQuery } = useMemo(
    () => qs.parse(location.search, { ignoreQueryPrefix: true }),
    [location.search]
  );
  const websiteId = websiteIdProp || websiteIdFromQuery;

  const [email, setEmail] = useState('');

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!websiteId) return;
      try {
        await addVip(websiteId, { email });
        alert('Update Saves');
        setEmail('');
      } catch (e1) {
        // Optionnel: afficher une notification d'erreur
        // console.error(e1);
      }
    },
    [websiteId, email]
  );

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h5" component="h1" sx={{ mb: 3 }}>
        Ajouter un VIP
      </Typography>

      <Box component="form" onSubmit={onSubmit} noValidate>
        <Stack spacing={2}>
          <TextField
            label="Email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="small"
            fullWidth
          />

          <Stack direction="row" justifyContent="flex-end">
            <Button type="submit" variant="contained">
              Soumettre
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
}

export default FormVip;